<div class="row justify-content-center g-0">
  <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6">

    @if(!processing() && pool) {
      <app-title title="formatie kiezen"></app-title>
    }

    @if(processing()) {
      <h2 class="text-center">
        <fa-icon [icon]=faSpinner [animation]="'spin'"></fa-icon>
      </h2>
    }
    @if(alert){
    <ngb-alert [type]="alert.type">{{ alert.message }}</ngb-alert>
    }
    @if(!processing() && pool) {
      <div class="d-flex flex-wrap justify-content-center">
        @for(formation of formations; track formation.getName()){
          <div class="card border-secondary pointer mt-3 mx-2"(click)="editFormation(pool,formation)">
            <div class="text-center card-header">
              <span>{{formation.getName()}}</span>
              @if(currentFormation === formation) {
                <fa-icon class="ms-1" [icon]=faCheckCircle></fa-icon>
              }
            </div>
            <div class="card-body p-1">
              @for(formationLine of formation.getLines(); track formationLine){
                <div class="d-flex justify-content-around">
                  @for(position of formationLine.getNumbers();track position) {
                    <div>
                      <div class="m-1">
                        <app-lineicon [line]="formationLine.getNumber()"></app-lineicon>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>


            <!-- 
            <div class="d-flex flex-wrap justify-content-center mb-3">
              <select class="form-control max-width" formControlName="formation">
                <option [ngValue]="undefined" selected>
                  kies formatie
                </option>
                <option *ngFor="let formation of availableFormations" [ngValue]="formation">
                  {{formation.getName()}}</option>
              </select>
            </div>
            -->

          </div>
        }
      </div>
    }
  </div>
</div>
    